<div class="row">
     <div class="col-12" >
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
                    Enroll in PSP</h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHTML]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="13" [totalSteps]="19"></app-complete-bar>
                              <h2 [innerHTML]="'ReviewHow_1' | translator:'base'">Review</h2>
                              <p class="step-text" [innerHTML]="'ReviewHow_2' | translator:'base'">How did you learn
                                   about PSP?</p>
                              <hr>
                              <div class="mb-3">
                                   <label class="form-label" for="DiscoveredVia">
                                        <span [innerHTML]="'ReviewHow_3' | translator:'base'">Select one of the
                                             following:</span>
                                        <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio" name="DiscoveredVia" id="DiscoveredViaEmail"
                                                  class="form-check-input" value="Email/Mail"
                                                  [(ngModel)]="enrollmentService.newCustomer!.discoveredPspVia"
                                                  />
                                             <span [innerHTML]="'ReviewHow_4' | translator:'base'">Email/Mail</span>
                                        </label>
                                   </div>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio" name="DiscoveredVia" id="DiscoveredViaTradeAssociation"
                                                  class="form-check-input" value="Trade Association"
                                                  [(ngModel)]="enrollmentService.newCustomer!.discoveredPspVia"
                                                  />
                                             <span [innerHTML]="'ReviewHow_5' | translator:'base'">Trade
                                                  Association</span>
                                        </label>
                                   </div>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio" name="DiscoveredVia" id="DiscoveredViaFmcsa"
                                                  class="form-check-input" value="FMCSA"
                                                  [(ngModel)]="enrollmentService.newCustomer!.discoveredPspVia"
                                                  />
                                             FMCSA
                                        </label>
                                   </div>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio" name="DiscoveredVia" id="DiscoveredViaPrintPublication"
                                                  class="form-check-input" value="Print Publication"
                                                  [(ngModel)]="enrollmentService.newCustomer!.discoveredPspVia"
                                                  />
                                             <span [innerHTML]="'ReviewHow_7' | translator:'base'">Print
                                                  Publication</span>
                                        </label>
                                   </div>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio" name="DiscoveredVia" id="DiscoveredViaOther"
                                                  class="form-check-input" value="Other"
                                                  [(ngModel)]="enrollmentService.newCustomer!.discoveredPspVia"
                                                  />
                                             <span [innerHTML]="'ReviewHow_8' | translator:'base'">Other</span>
                                        </label>
                                   </div>
                              </div>
                              <div *ngIf="enrollmentService.newCustomer!.discoveredPspVia === 'Other'"
                                   [formGroup]="companyInfo">
                                   <label for="DiscoveredViaOtherText" class="form-label">
                                        <span [innerHTML]="'ReviewHow_8' | translator:'base'">Other</span>:<span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <input type="text" formControlName="discoveredViaOther" name="DiscoveredViaOtherText"
                                        id="DiscoveredViaOtherText" class="form-control bg-light"
                                        maxlength="50" />
                                   <div *ngIf="discoveredViaOther!.invalid && discoveredViaOther!.dirty"
                                        class="help-block text-danger">
                                        <div *ngIf="discoveredViaOther!.errors?.['required']"
                                             [innerHTML]="'Required' | translator:'base'">
                                        </div>
                                        <div *ngIf="discoveredViaOther!.errors?.['maxlength']"
                                             [innerHTML]="'DiscoveredViaOther_max' | translator:'base'">
                                        </div>
                                        <div *ngIf="discoveredViaOther!.errors?.['pattern']"
                                             [innerHTML]="'DiscoveredViaOther_invalid' | translator:'base'">
                                        </div>
                                   </div>
                              </div>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/18" (click)="scrollToTop()"
                                             [disabled]="pageValid()" class="btn btn-primary btn-strong"
                                             [title]="'ReviewHow_9' | translator:'base'"
                                             name="companyNext18" id="companyNext18">
                                             <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only" [innerHTML]="'ReviewHow_9' | translator:'base'">Terms
                                                  & Conditions</span>
                                        </button>
                                   </div>
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/16" class="btn btn-outline-primary"
                                             (click)="scrollToTop()" [title]="'Review' | translator:'base'" 
                                             name="companyBack18" id="companyBack18">
                                             <span [innerHTML]="'Back' | translator:'base'">Back</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only"
                                                  [innerHTML]="'ReviewHow_10' | translator:'base'">Review Users</span>
                                        </button>
                                        <button routerLink="/" class="btn btn-light" (click)="scrollToTop()"
                                             name="companyCancel18" id="companyCancel18"
                                             [innerHTML]="'Cancel' | translator:'base'"
                                             [title]="'Cancel' | translator:'base'"></button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="4"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
</div>